import { render, staticRenderFns } from "./historyDetail.vue?vue&type=template&id=9a733496&scoped=true&"
import script from "./historyDetail.vue?vue&type=script&lang=js&"
export * from "./historyDetail.vue?vue&type=script&lang=js&"
import style0 from "./historyDetail.vue?vue&type=style&index=0&id=9a733496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a733496",
  null
  
)

export default component.exports